import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { v4 as uuidv4 } from "uuid";
import { independentFunction } from "../../pages/Common/CommonFunctions/commonFunctions";

const HireneuronToolTip = (props) => {
  // Create Ref
  const textElementRef = useRef();

  const compareSize = () => {
    if (
      textElementRef.current !== undefined &&
      textElementRef.current !== null
    ) {
      if (
        textElementRef.current.scrollWidth !== undefined &&
        textElementRef.current.scrollWidth !== null &&
        textElementRef.current.clientWidth !== undefined &&
        textElementRef.current.clientWidth !== null
      ) {
        const compare =
          textElementRef.current.scrollWidth >
          textElementRef.current.clientWidth;
        setTimeout(() => {
          setHover(compare);
        }, 1000);
      }
    }
  };

  // compare once and add resize listener on "componentDidMount"
  useEffect(() => {
    compareSize();
    window.addEventListener("resize", compareSize);
  }, [props.value]);

  // remove resize listener again on "componentWillUnmount"
  useEffect(
    () => () => {
      window.removeEventListener("resize", compareSize);
    },
    [],
  );

  // Define state and function to update the value
  const [hoverStatus, setHover] = useState(false);

  return (
    <Tooltip
      placement={
        props.placement !== null && props.placement !== undefined
          ? props.placement
          : "top-start"
      }
      title={props.value}
      disableHoverListener={!hoverStatus}
      style={{ fontSize: "2em" }}
    >
      <div
        key={uuidv4()}
        ref={textElementRef}
        className="max-width-95"
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {props.phoneNumber !== undefined &&
        props.phoneNumber !== null &&
        props.phoneNumber !== "" ? (
          <>
            {props.label && props.label.length > 0 && (
              <span className="list-label">{props.label}</span>
            )}
            {props.phoneNumber && props.phoneNumber.length > 0 ? (
              <a href={props.phoneNumber}>{props.someLongText}</a>
            ) : (
              props.someLongText
            )}
          </>
        ) : (
          <>
            {props.label && props.label.length > 0 && (
              <span className="list-label">{props.label}</span>
            )}
            {props.link && props.link.length > 0 ? (
              <Link to={props.link}>{props.someLongText}</Link>
            ) : (
              props.someLongText
            )}
          </>
        )}
      </div>
    </Tooltip>
  );
};

export default HireneuronToolTip;
